<template>
  <div class="questionnaire-view">
    <div class="common-parse-session-card">
      <div class="card-title">{{ customContent.title }}</div>
      <div class="card-body">
        <span class="body-content">{{ customContent.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireView',
  props: {
    customContent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.questionnaire-view {
  padding: 5px 16px;
  white-space: normal;
}
.card-body {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;
}
.body-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/QuestionnaireView.vue